<template>
  <div class="mb-3">
    <file-upload
      :input-id="inputId"
      :ref="inputId"
      class="dr-file-upload-action"
      v-model="files"
      drop
      dropDirectory
      :multiple="model.Multiple"
      :headers="headers"
      :size="size"
      :chunk-enabled="true"
      :chunk="chunk"
      :post-action="chunk.action"
      :disabled="loading || isDisabled"
      @input-file="inputFile"
      @input-filter="checkFilesExtensions"
    >
      <div class="dr-file-upload-content">
        <div class="file-label">
          {{ getLabel() }}
        </div>
        <v-file-input label="File input" :regular="isRegular" :solo="isSolo" :outlined="isOutlined" :filled="isFilled"></v-file-input>
        <div v-if="!model.Multiple">
          <div v-for="item in files" :key="item.id" class="dr-file-upload-progrecc-corcilar">
            <v-progress-circular :size="25" :value="item.progress" :width="3" color="primary" class="caption" v-if="loading" />
            <v-icon v-else-if="!loading && !errors" color="success">mdi mdi-check</v-icon>
          </div>
        </div>
      </div>
    </file-upload>
    <div v-if="model.Multiple" class="uploaded-files-container">
      <div v-for="item in files" :key="item.id" class="uploaded-files pa-2 ml-8">
        <div class="d-flex align-center">
          <v-icon>mdi-file-document-outline</v-icon>
          <span class="ml-1">{{ item.name }}</span>
        </div>
        <div class="d-flex align-center">
          <div class="mr-2">
            <v-progress-circular :size="25" :value="item.progress" :width="3" color="primary" class="caption" v-if="loading" />
            <v-icon v-else-if="!loading && !errors" color="success">mdi mdi-check</v-icon>
            <v-icon v-if="!loading && !errors" style="cursor: pointer" @click="deleteFile(item)">mdi-delete</v-icon>
          </div>
        </div>
      </div>
    </div>
    <p v-if="errors && this.model.ErrorMessage" class="font-weight-bold d-flex justify-center" style="color: red">
      {{ this.model.ErrorMessage }}
    </p>
  </div>
</template>

<script>
import inputMixin from '../../mixins/input-mixin'
import baseMixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import fileUpload from 'vue-upload-with-credential'
import actionMixin from '../../mixins/actions-mixin'
import uk from '../../langs/dr-file-input/uk.json'
import ru from '../../langs/dr-file-input/ru.json'
import en from '../../langs/dr-file-input/en.json'

export default {
  name: 'dr-file-input-component',
  mixins: [inputMixin, baseMixin, actionMixin, widgetsWrapperMixin],
  components: {
    fileUpload
  },
  i18n: {
    messages: {
      uk,
      ru,
      en
    }
  },
  data: () => ({
    files: [],
    size: null,
    headers: { 'Upload-Type': 'single' },
    chunk: {
      action: window.appConfig.GraphQlUrl + 'upload',
      minSize: 512000,
      maxActive: 1,
      maxRetries: 10
    },
    filesWithWrongExtensions: 0,
    _label: null,
    loading: false,
    errors: false,
    inputId: `uploadId/${new Date().getMilliseconds()}`
  }),
  created() {
    this.size = this.model.MaxSize == (undefined || '') ? 2097152 : this.model.MaxSize * 1024 * 1024
  },

  watch: {
    filesWithWrongExtensions: function (filesCount) {
      // Если нет файлов с некорректным расширением - ничего не делаем
      if (filesCount === 0) {
        return
      }
      // Показать тост c ошибкой
      this.showFilterErrorMessage()
    }
  },

  methods: {
    deleteFile(file) {
      // Удалить файл из массива всех файлов data
      const indexFileForDeletion = this.files.findIndex((e) => e.id === file.id)
      this.files.splice(indexFileForDeletion, 1)

      let dataSourceFilesValues = this.getDataSourceField(this.model.Value)
      let dataSourceFilesNames = this.getDataSourceField(this.model.FileName)
      
      // Удалить fileName из текущего датасоурса
      const dataSourceFileNameIndex = dataSourceFilesNames.findIndex((e) => e === file.name)
      dataSourceFilesNames.splice(dataSourceFileNameIndex, 1)
      this.setDataSourceField(this.model.FileName, ...dataSourceFilesNames)

      // Удалить fileValue из текущего датасоурса
      const dataSourceFileValueIndex = dataSourceFilesValues.findIndex((e) => e === file.response.fileName)
      dataSourceFilesValues.splice(dataSourceFileValueIndex, 1)
      this.setDataSourceField(this.model.Value, ...dataSourceFilesValues)
    },
    showFilterErrorMessage() {
      let message = this.$t('drFileInput.filterError', { extensions: this.model?.AvailableFileExtensions })

      this.$store.commit('SET_NOTIFY', {
        text: this.$t(message),
        color: 'warning'
      })

      this.filesWithWrongExtensions = 0
    },
    getLabel() {
      if (this.model.Multiple) {
        return this.$t('drFileInput.addFiles')
      }
      return this._label || this.evaluateExpression(this.model.Label)
    },
    // Проверка файлов на соответствие разрешенным расширениям при выборе файлов 
    checkFilesExtensions(newFile, oldFile, prevent) {
      if (!this.model?.AvailableFileExtensions) {
        return
      }
      const extensions = this.model?.AvailableFileExtensions?.replace(',', '|')
      const availableExtensionsRegex = new RegExp(`.(${extensions})$`)
      // Если есть файл, он не сделал запрос к graphql и его расширение соответствует указаным
      if (newFile && !oldFile && availableExtensionsRegex.test(newFile?.file?.name)) {
        this.filesWithWrongExtensions += 1
        return prevent()
      }
    },
    inputFile(newFile, oldFile) {
      if (!newFile) {
        return
      }
      // Если размер файла выше чем установленый
      if (newFile.size > this.size) {
        this.errors = true
        this.files = []
        return
      }

      this.errors = false
      // указываем что идёт загрузка файла и лейбл для файла в режиме single
      if (!this.loading) {
        this.loading = true
        this._label = newFile.name
      }
      // сделать запрос нашего файла к graphql
      if (newFile && !oldFile) {
        this.$refs[this.inputId].active = true
      }
      // Обработка файла с корректным респонсом с graphql
      if (newFile && oldFile && newFile.success !== oldFile.success) {
        if (this.model.Multiple) {
          this.setDataSourceField(this.model.Value, [...this.getDataSourceField(this.model.Value), newFile.response.fileName])
          this.setDataSourceField(this.model.FileName, [...this.getDataSourceField(this.model.FileName), newFile.name])
        } else {
          this.setDataSourceField(this.model.Value, newFile.response.fileName)
          this.setDataSourceField(this.model.FileName, newFile.name)
        }
        this.$refs[this.inputId].active = this.loading = false
      }

      this.invokeActionOnClick(this.model.GenerationOnChange, { value: { newFile, oldFile } })
    }
  }
}
</script>

<style>
.uploaded-files {
  border-bottom: none;
  display: flex;
  justify-content: space-between;
}

.dr-file-upload-action {
  display: block !important;
  padding-top: 2px;
  padding-right: 2px;
}

.file-label {
  position: absolute;
  top: 22px;
  left: 40px;
  color: rgba(0, 0, 0, 0.6);
  z-index: 1;
}

.dr-file-upload-content {
  display: flex;
}
.dr-file-upload-progrecc-corcilar {
  position: relative;
  top: 20px;
}
</style>